import React from 'react';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/TourGallerySection/TourGallerySection.styels';
import { GridsGallery } from 'views/rebranded-module/common/components';

const TourGallerySection = (props) => {
  const { cmsData, mediaItems } = props;
  return (
    <StyledBox>
      <GridsGallery mediaItems={mediaItems} content={cmsData} />
    </StyledBox>
  );
};

export { TourGallerySection };
